import { connect } from 'react-redux';
import React from 'react';import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import Products from './components/Products';
import { customer } from '../../../../modules';
import Box from '../../profilePage/components/Box';
import BoxesRow from '../../profilePage/components/BoxesRow';
import ActionButton from '../../../components/ActionButton';



class SoftwareProducts extends React.Component {

    getButtons = () => [
        <ActionButton icon="user" to={'/#/customer/' + this.props.customerId + '/order'} title="Legg til produkter" icon="plus" />
    ];

    render = () => <BoxesRow>
        <Box label="Abonnement" buttons={this.getButtons()}>
            <Products/>
        </Box>
    </BoxesRow>
}

const mapStateToProps = createStructuredSelector({
    customerId: customer.profile.selectors.getCustomerID
});

export default connect(mapStateToProps)(SoftwareProducts);


